import React from "react";
import AutoScroll from "./AutoScroll";
import { WhatsAppIcon } from "./TopSelling";

export default function WhatsAppFloat() {
  return (
    <a
      data-testid="whatsapp-float"
      href={`https://wa.me/917208819922?text=${encodeURIComponent("Namaste Rudralife, I need guidance on choosing a Rudraksha.")}`}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-24 right-4 z-40 flex h-13 w-13 items-center justify-center rounded-full bg-[#25D366] p-3.5 text-white shadow-[0_10px_30px_-6px_rgba(37,211,102,0.6)] transition-transform duration-300 hover:scale-110 md:bottom-8 md:right-6"
    >
      <WhatsAppIcon size={26} />
    </a>
  );
}
